import {
  store,
  bridge,
  time,
  Scheduler,
  Entity,
  configs,
} from "@dinahmoe/dmafjs-core";

class AssetLoader extends Entity {
  namespace = "assets:loader";
  engine = "assets";

  init(node) {
    super.init(node);
    bridge.create({ ...this.getInitData(node), uid: this.engine + "/" + node.uid, sender: "core" });

    node.pendingLoaded = false;
    node._filesLoaded = 0;
    node.pendingLoad = new Scheduler(this, this.doLoad.bind(this, node));
    node.pendingUnload = new Scheduler(this, this.doUnload.bind(this, node));
  }

  execute(node, config, event) {
    if (node.props["loading.auto"]) {
      this.load(node, config, event);
    }
  }

  load(node, config, event) {
    const loadAtTime = event.time + node.props["loading.delay"];
    node["source.files"] = node["source.files"].map((file) => configs.resolveConfig(file, event));
    node.pendingUnload.clear();
    node.pendingLoad.clear();

    node.pendingLoad.schedule(loadAtTime, loadAtTime);
  }

  unload(node, config, event) {
    const unloadAtTime = event.time + node.props["loading.delay"];

    node.pendingLoad.clear();
    node.pendingUnload.clear();
    node.pendingUnload.schedule(unloadAtTime, unloadAtTime);
  }

  doLoad(node) {
    switch (node.props["loading.state"]) {
      case "unloaded":
        bridge.update({
          uid: "assets/" + node.uid,
          key: "load",
          value: {
            files: node.props["source.files"],
            path: node.props["source.path"],
            ignoreFolder: node.props["source.ignoreFolder"],
          },
          sender: "core",
        });
        break;
      case "loading":
        //this.dispatch(this.uid + ":loading");
        break;
      case "loaded":
        this.dispatch(`${node.uid}:complete`);
        if (node.pendingLoaded) {
          this.dispatch(`${node.uid}:loaded`);
          node.pendingLoaded = false;
        }
        break;
    }
  }


  receiveMessage(node, message) {
    const eventType = message.key;
    switch (eventType) {
      case "loading":
        node.props["loading.state"] = "loading";
        //this.dispatch(`${node.uid}:loading`);
        break;
      case "complete":
        node.props["loading.state"] = "loaded";
        this.dispatch(`${node.uid}:complete`);
        if (node.pendingLoaded) {
          this.dispatch(`${node.uid}:loaded`);
          node.pendingLoaded = false;
        }
        break;
      case "file":
        //extra file means loading was caused in process of original file loading, e.g. Samples audios are loaded during Sampler file loading and parsing
        if (!message.value.extraFile) {
          node._filesLoaded++;
          node["loading.percent"] = Math.round((node._filesLoaded / node["source.files"].length) * 100);
        }
        store.set(message.value.key, message.value.content);
        break;
      case "unload":
        store.remove(message.value.key);
        break;
      case "unloaded":
        node.props["loading.state"] = "unloaded";
        this.dispatch(`${node.uid}:unloaded`);
        break;
    }
  }

  checkState(node) {
    switch (node.props["loading.state"]) {
      case "unloaded":
        node.pendingLoaded = true;
        this.dispatch(`${node.uid}:unloaded`);
        break;
      case "loading":
        node.pendingLoaded = true;
        this.dispatch(`${node.uid}:loading`);
        break;
      case "loaded":
        this.dispatch(`${node.uid}:loaded`);
        break;
    }
  }

  doUnload(node) {
    bridge.update({
      uid: "assets/" + node.uid,
      key: "unload",
      value: {
        files: node.props["source.files"],
        ignoreFolder: node.props["source.ignoreFolder"],
      },
      sender: "core",
    });
  }

  destroy(node) {
    bridge.update({
      uid: "assets/" + node.uid,
      key: "destroy",
      value: {
        files: node.props["source.files"],
        ignoreFolder: node.props["source.ignoreFolder"],
      },
      sender: "core",
    });

  }
}

const assetLoader = new AssetLoader();
export { assetLoader, AssetLoader };
